import { render, staticRenderFns } from "./repairManagement.vue?vue&type=template&id=3b97ced8&scoped=true&"
import script from "./repairManagement.vue?vue&type=script&lang=js&"
export * from "./repairManagement.vue?vue&type=script&lang=js&"
import style0 from "./repairManagement.vue?vue&type=style&index=0&id=3b97ced8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97ced8",
  null
  
)

component.options.__file = "repairManagement.vue"
export default component.exports